export default __webpack_public_path__ + "static/media/DernekLogoName.9b18188c.jpg";